module.exports = __webpack_public_path__ + "static/img/popular_icon_sign.dbeda50.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/popular_icon_sign.png
// module id = D4O2
// module chunks = 1